import { render, staticRenderFns } from "./replaceCertDialog.vue?vue&type=template&id=0a0930fc&scoped=true"
import script from "./replaceCertDialog.vue?vue&type=script&lang=js"
export * from "./replaceCertDialog.vue?vue&type=script&lang=js"
import style0 from "./replaceCertDialog.vue?vue&type=style&index=0&id=0a0930fc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a0930fc",
  null
  
)

export default component.exports